import { Component, Input, Output, EventEmitter } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from '../_shared/components/navbar/navbar.component';
import { SidebarComponent } from './_shared/components/sidebar/sidebar.component';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [RouterModule, NavbarComponent, SidebarComponent],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent {
  @Input() isCollapsed: boolean = false;
  @Input() openSidebar: boolean = false;
  @Output() toggleCollapse = new EventEmitter<void>();
  @Input() closeSidebar!: () => void;

  onToggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  sidebarToggle(): void {
    this.openSidebar = !this.openSidebar;
  }

  sidebarToggleClose(): void {
    this.openSidebar = false;
  }
}